export const TOGGLE_USER = "TOGGLE_USER";
export const CLOSE_USER = "CLOSE_USER";
export const LOGOUT = "LOGOUT";
